import { render, staticRenderFns } from "./ArrowSelectionItem.vue?vue&type=template&id=128380cf&scoped=true"
import script from "./ArrowSelectionItem.vue?vue&type=script&lang=js"
export * from "./ArrowSelectionItem.vue?vue&type=script&lang=js"
import style0 from "./ArrowSelectionItem.vue?vue&type=style&index=0&id=128380cf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128380cf",
  null
  
)

export default component.exports